'use strict';

const Mediator = require('./../../../core/mediator');
const Translator = require('./../../../core/translator');
const Loader = require('./../../../services/loader');
const zone = require('./../../../services/structure/zone');
const plugins = require('./../mobile/plugins');
const contentScroller = require('./../mobile/service/contentScroller');
const placeholder = require('./../service/textPlaceholder');

module.exports = {
    'empty': function(content) {
        content.stopAddEvent = true;
    },
    'desktop': {
        'before': {
            'basic': function() {
                return;
            },
        },
        'after': {
            'basic': function(content) {
                if (content.stopAddEvent !== true) {
                    content.$.mouseenter();
                    content.$.find('.btn-parameter').click();
                }
            },
            'text': function(content) {
                content.stopAddEvent = true;
            },
            'noAction': function(content) {
                content.stopAddEvent = true;

                return;
            },
        },
        'afterSubmitParameters': {
            'text': function(content) {
                placeholder.apply(content);
            },
        },
    },
    'mobile': {
        'before': {
            'basic': function(data) {
                if (data.stopAddEvent !== true) {
                    zone.setSmallPanel(Translator.translate('settings'), '');
                    Loader.start();
                }
            },
            'hidePanels': function(data) {
                data.stopAddEvent = true;

                Loader.start();
                zone.hidePanels();
            },
        },
        'after': {
            'showMenu': function(content) {
                content.stopAddEvent = true;

                Loader.stop();
                plugins.openMenu(content, function() {
                    contentScroller.scroll(content);
                });
            },
            'basic': function(content) {
                if (content.stopAddEvent !== true) {
                    Mediator.publish('menu:configure-content:click', {
                        'params': {
                            'content': content,
                        },
                    });
                }
            },
        },
    },
};
